import { useCallback, useEffect, useRef } from 'react';

const useWindowScrollPosition = ({ isScrollTrackingDisabled = false }) => {
  const position = useRef({ x: 0, y: 0 });
  const updatePosition = useCallback(() => {
    const { scrollX, scrollY } = window;
    if (position.current.x !== scrollX || position.current.y !== scrollY) {
      position.current.x = scrollX;
      position.current.y = scrollY;
    }
  }, []);

  useEffect(() => {
    if (!isScrollTrackingDisabled) {
      updatePosition();

      window.addEventListener('scroll', updatePosition, {
        capture: false,
        passive: true,
      });
    }

    return () => {
      window.removeEventListener('scroll', updatePosition);
    };
  }, [isScrollTrackingDisabled, updatePosition]);

  return position.current;
};

export default useWindowScrollPosition;
